import { Button } from "@design-system/Button/Button";

// eslint-disable-next-line react-refresh/only-export-components
export const CATALOG_ITEM_CREATE_CTA_TITLE = "Add an item to get started";
// eslint-disable-next-line react-refresh/only-export-components
export const CATALOG_ITEM_CREATE_CTA_SUBTITLE =
    "Create, manage, and track all your items in one place.";

interface CatalogItemCreateButtonProps {
    onAddItem: () => void;
}

export const CatalogItemCreateButton: React.FC<
    CatalogItemCreateButtonProps
> = ({ onAddItem }) => (
    <Button variant="primary" size="md" onClick={onAddItem}>
        Add item
    </Button>
);
